import * as requestFromServer from './crud';
import {slice, callTypes} from './slice';
import {messages as M} from '../../../../../../../_metronic/i18n/messages';
import {showGlobalMessage} from '../../../../../_common/actions/globalMessage/showGlobalMessage';
import {invoicesSlice} from '../../../../_redux/invoicesSlice';
import {logUserAction} from '../../../../../../../utils';
import {pages as P} from '../../../../../_common/constants/pages';
import {actionTypes as T} from '../../../../../_common/constants/actionTypes';
import {subjects as S} from '../../../../../_common/constants/subjects';
import {logMessages as L} from '../../../../../_common/constants/logMessages';

const {actions} = slice;
const {actions: invoicesActions} = invoicesSlice;

export const createInvoiceReceipt = (data: {invoiceID: string}) => async (dispatch: (fn: any) => unknown) => {
  const {invoiceID, ...rest} = data;

  try {
    const response = await requestFromServer.createInvoiceReceipt(rest);
    const {errorCode, data: responseData} = response.data as {errorCode: number, data: {receiptID: string}};
    logUserAction(
      P.INVOICES,
      S.RECEIPT,
      T.CREATE,
      L.INVOICES_CREATE_INVOICE_RECEIPT(invoiceID),
      errorCode
    );
    const {receiptID} = responseData;
    if (errorCode === 0) {
      dispatch(invoicesActions.addReceiptToInvoice({invoiceID, receiptID}));
      dispatch(showGlobalMessage(M.REQUEST_ENDED_SUCCESSFULLY));
    } else {
      // @ts-ignore
      dispatch(showGlobalMessage(M[errorCode.toString()]));
    }

    return errorCode;
  } catch (error) {
    console.error({error});
    (error as {[p: string]: string}).clientMessage = 'Can\'t send data';
    dispatch(actions.catchError({error, callType: callTypes.data}));
  }
};
